<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <div class="c-o-my-pages-section__message" v-if="errorMessages.length > 0">
                <message type="error">
                    <div class="o-wysiwyg">
                        <ul>
                            <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
                        </ul>
                    </div>
                </message>
            </div>
            <h2 class="c-o-my-pages-section__heading">Grunduppgifter</h2>
            <h3>{{company.Title}}</h3>
            <!-- <rating v-if="company.Rating" :ratingValue="company.Rating" :nrOfRatings="company.NrOfRatings"></rating> -->
            <div class="c-o-my-pages-section__form">
                <div class="c-o-my-pages-section__form-block">
                    <image-upload
                        v-model="logo"
                        title="Logotyp"
                        name="Logo"
                        info="Visas på er presentation och i listningar."
                        :id="company.Id">
                    </image-upload>
                </div>
                <div class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half">
                    <input-field
                        v-model="address"
                        :label="'Adress'"
                        :placeholder="'Ex. Stadsvägen 42'"
                        name="company-address"
                        :id="44">
                    </input-field>
                </div>
                <div class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation':  errors.postalWithCity}"
                >
                    <input-field
                        v-model="postalWithCity"
                        :label="'Postnummer & ort'"
                        :placeholder="'Ex. 124 95 Stockholm eller 12495 Stockholm'"
                        name="company-phone"
                        :id="45"
                        :invalid=" errors.postalWithCity">
                    </input-field>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation':  errors.phone}">
                    <input-field-phone
                        v-model="phone"
                        :label="'Telefon'"
                        placeholder="Ex. 070-123 45 67"
                        name="company-phone"
                        :id="46"
                        :invalid=" errors.phone">
                    </input-field-phone>
                </div>
                <div
                    class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half"
                    :class="{'c-o-my-pages-section__form-block--invalid-animation':  errors.email}"
                >
                    <input-field-email
                        v-model="email"
                        :label="'E-post'"
                        :placeholder="'Ex. namn@minhemsida.se'"
                        name="company-email"
                        :id="47"
                        :invalid=" errors.email">
                    </input-field-email>
                </div>
                <div class="c-o-my-pages-section__form-block c-o-my-pages-section__form-block--half">
                    <input-field
                        v-model="website"
                        :label="'Hemsida'"
                        :placeholder="'Ex. https://minhemsida.se'"
                    ></input-field>
                </div>
            </div>
            <div class="c-o-my-pages-section__save-button">
                <success-button :currentState="saveState" @buttonClicked="save"></success-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapMutations, mapActions } from 'vuex';

    import {
        UPDATE_COMPANY_DATA,
        SAVE_COMPANY_MAIN_INFO,
        GET_SAVE_ERROR
    } from '../../../../../../store/store-models/my-pages-company-model';

    import { timeout } from '../../../../../../helpers';
    import { hasErrors, setErrors, isEmailValid, isPhoneValid, isPostalWithCityValid } from '../../../../../../helpers/error-validation';

    import Rating from '../../../../atoms/AtomRating.vue';
    import InputField from '../../../../atoms/form/AtomInputText.vue'
    import InputFieldEmail from '../../../../atoms/form/AtomInputEmail.vue'
    import InputFieldPhone from '../../../../atoms/form/AtomInputPhone.vue'
    import ImageUpload from '../../../../atoms/form/AtomImageUpload.vue'
    import SuccessButton from '../../../../atoms/AtomSuccessButton.vue'
    import Message from '../../../../molecules/MoleculeMessage.vue'

    export default {
        props: [
            'company'
        ],
        components:{
            Rating,
            InputField,
            InputFieldEmail,
            InputFieldPhone,
            ImageUpload,
            SuccessButton,
            Message
        },
        data() {
            return {
                errorMessages: [],
                file: null,
                errors: {
                    phone: false,
                    postalWithCity: false,
                    email: false
                },
                saveState: 'default',
            }
        },
        computed: {
            saveError: function() {
                return this.$store.getters[GET_SAVE_ERROR]('mainInfo');
            },
            logo: {
                get() {
                    return this.company.Logo;
                },
                set(value) {
                    this.file = value;
                    if(value == null)
                        this.$store.dispatch(UPDATE_COMPANY_DATA, { 'Logo': null });
                }
            },
            address: {
                get(){
                    return this.company.VisitAddress;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_DATA, { 'VisitAddress': value });
                }
            },
            postalWithCity: {
                get(){
                    return this.company.VisitCity ? this.company.VisitCity.trim() : '';
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_DATA, { 'VisitCity': value });
                }
            },
            phone: {
                get(){
                    return this.company.Phone;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_DATA, { 'Phone': value });
                }
            },
            email: {
                get(){
                    return this.company.Email;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_DATA, { 'Email': value });
                }
            },
            website: {
                get(){
                    return this.company.Url;
                },
                set(value){
                    this.$store.dispatch(UPDATE_COMPANY_DATA, { 'Url': value });
                }
            }
        },
        methods: {
            ...mapActions({
                saveMainInfo: SAVE_COMPANY_MAIN_INFO,
            }),
            async save(){
                this.errorMessages = [];
                setErrors(this.errors, ['phone', 'email', 'postalWithCity'], false);

                if( this.email && !isEmailValid(this.email) ) {
                    this.errorMessages.push('Fyll i en korrekt mailadress');
                    setErrors(this.errors, ['email'], true);
                }

                if(this.phone && !isPhoneValid(this.phone) ) {
                    this.errorMessages.push('Fyll i ett korrekt telefonnummer. (Ex. 070-123 45 67)');
                    setErrors(this.errors, ['phone'], true);
                }

                if(this.postalWithCity && !isPostalWithCityValid(this.postalWithCity) ) {
                    this.errorMessages.push('Fyll i ett korrekt postnummer. (Ex. 124 95 Stockholm)');
                    setErrors(this.errors, ['postalWithCity'], true);
                }

                if( hasErrors(this.errors, ['phone', 'email', 'postalWithCity']) ) {
                    this.saveState = 'error';
                    return;
                }

                this.saveState = 'processing';

                try {
                    const result = await this.saveMainInfo(this.file);
                    this.saveState = 'success';
                } catch(e) {
                    this.saveState = 'error';
                    this.errorMessages.push(this.saveError);
                }

                await timeout();
                this.saveState = 'default';
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismMyPagesMainInfo.vue